// The pig bank — the full roster of decorative pig variants. Each is the same
// base pixel pig wearing a different outfit; the image files live in /public.
// The home page pulls a random handful of these into its scroll-gutter slots,
// so the cast you see changes on every visit.
//
// To add a pig: drop a `pig-<name>.png` (or .gif/.webp) in /public and add its
// filename here. (The hero mascot `pig-icon.png` is intentionally left out — it
// stays reserved as the brand mark.)
const FILES = [
  'pig-cop.png',
  'pig-cowboy.png',
  'pig-drink.png',
  'pig-logo.gif',
  'pig-viking.webp',
  'pig-ski.png',
  'pig-wizard.png',
  'pig-pirate.png',
  'pig-king.png',
  'pig-ninja.png',
  'pig-warrior.png',
  'pig-armored.png',
  'pig-heavy.png',
  'pig-rogue.png',
  'pig-deathknight.png',
  'pig-hunter.png',
];

const P = process.env.PUBLIC_URL;

export const PIG_BANK = FILES.map((f) => `${P}/${f}`);

// Return `n` distinct pigs in random order (Fisher–Yates). If `n` exceeds the
// bank size you simply get the whole bank, shuffled.
export function pickPigs(n = PIG_BANK.length) {
  const a = [...PIG_BANK];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a.slice(0, n);
}
